import { Theme } from 'react-select';

export const getCommonTheme = (theme: Theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#3173b1',
    neutral20: '#e0e0e0',
    neutral30: '#e0e0e0',
  },
});
